import {Controller} from "stimulus"

export default class extends Controller {
    static targets = [ "form", "contractCode" ]

    checkForm(event) {
        event.preventDefault()

        const affiliateCode = this.formTarget.dataset.socialAffiliatecode
        const planType = this.formTarget.dataset.socialPlantype
        const stayCareCode = this.formTarget.dataset.socialStaycarecode
        let finalPath = this.formTarget.dataset.socialPath

        const params = []
        if (planType != null){
            params.push(`plan_type=${planType}`)
        }
        if (affiliateCode != null){
            params.push(`affiliate_code=${affiliateCode}`)
        }
        if (stayCareCode != null){
            params.push(`stay_care_code=${stayCareCode}`)
        }
        if (params.length > 0) {
            finalPath = `${finalPath}&${params.join('&')}`
        }

        if (affiliateCode === 'saison-cp-rg') {
            const contractCode = document.getElementById('contract_code')?.value
            if (!contractCode) {
                const errorMessage = this.element.querySelector('.error-message')
                errorMessage.textContent = '家賃保証ご契約番号の入力が必要です。'
                return false
            }

            // contract_codeの値を設定
            finalPath = `${finalPath}&contract_code=${contractCode}`
        }
        // パスを更新してsubmit
        this.formTarget.action = finalPath
        this.formTarget.submit()
    }
}